<template>
	<inertia-head title="Home" />
	<ContentSlot ref="contentSlot" :errors="errors" :flash="flash"/>

	<modal ref="confirmDeletePostModal" :hide_close="true">
		<template #title>Delete Post?</template>
		<template #body>
			<p>Are you sure you want to delete your post? You can't undo this process.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmDeletePostModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="deletePost()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>

	<modal ref="confirmLockUnlockPostModal" :hide_close="true">
		<template #title>Lock Post?</template>
		<template #body>
			<p>Are you sure you want to {{formPost.lock_post==1 ? 'lock' : 'unlock'}} the post?.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmLockUnlockPostModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="lockUnlockPost()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>


	<modal ref="confirmSpamPostModal" :hide_close="true">
		<template #title>Delete Post?</template>
		<template #body>
			<p>Are you sure you want to report as a spam? You can't undo this process.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmSpamPostModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="spamPost()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>

	<modal ref="joinConfirmModal" size="modal-md">
		<template #title>CONFIRMATION</template>
		<template #body>
			<div class="text-center fw-bold mb-5">Are you sure you want to leave?</div>
		</template>
		<template #footer>
			<button @click="joinConfirmModal.toggleModal" type="button" class="btn btn-alt-secondary">
				No
			</button>
			<button @click="joinCommunityProcess('yes')" type="button" class="btn btn-alt-success">
				Yes
			</button>
		</template>
	</modal>

	<div v-if="community!==null" class="py-0">
		<div class="bg-secondary px-5">
			<div class="content-header">
				<div class="space-x-1"></div>
				<div class="space-x-1">
					<button type="button" class="btn btn-sm btn-default"><i class="fa fa-edit text-white"></i></button>
				</div>
			</div>
		</div>
		<div class="content py-0">
			<div class="content-header">
				<div class="space-x-1 community-home-header">
					<div class="d-inline-block">
						<img
							class="img-avatar img-avatar96 me-1 user-avatar img-avatar-thumb" style="margin-top:-75px;"
							:src="community.icon_logo"
						/>
					</div>
					<div class="d-inline-block ms-2 mb-0 h1 text-black title">
						c/{{community.community_name}}
					</div>
					
				</div>
				<div class="space-x-1 d-none d-sm-table-cell">
					<inertia-link href="/member/community/post/create" class="btn btn-sm btn-outline-info rounded-pill me-1"><i class="fa fa-plus me-1"></i>Create Post</inertia-link>
					<button v-if="community.status!='Public' && community.join_status!='Declined'" @click="joinCommunity()" type="button" class="btn btn-sm rounded-pill" 
						:class="{'btn-success':community.join_status=='Joined','btn-warning':community.join_status=='Requesting','btn-info':community.join_status=='Join'}"
					>
						<div
							v-if="formJoinCommunity.processing"
							class="spinner-border spinner-border-sm text-white me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						{{community.join_status}}
					</button>
					<button v-if="community.status!='Public' && community.join_status=='Declined'" type="button" class="btn btn-sm btn-outline-danger rounded-pill disabled">
						{{community.join_status}}
					</button>
				</div>
			</div>

			<div class="content-header mobile-show d-none">
				<div class="mt-1 fs-xs">
					<div class="mt-1 mb-2">
						<span class="fs-xs"><i class="fa fa-calendar me-1"></i>Created {{community.created_at}}</span>
						<span class="fs-xs ms-3"><i class="fa me-1" :class="{'fa-globe':community.status=='Public','fa-eye':community.status=='Restricted','fa-lock':community.status=='Private'}"></i>{{community.status}}</span>
					</div>
					<div class="row">
						<div class="col">
							<div class="text-info fw-bold">{{community.total_members}}</div>
							<span class="fs-xs">Member</span>
						</div>
						<div class="col">
							<div class="text-info fw-bold">{{community.total_members}}</div>
							<span class="fs-xs">Visit</span>
						</div>
						<div class="col">
							<div class="text-info fw-bold">{{community.total_members}}</div>
							<span class="fs-xs">Online</span>
						</div>
					</div>
				</div>
			</div>

			<div class="mobile-show d-none mt-3">
				<inertia-link href="/member/community/post/create" class="btn btn-sm btn-outline-secondary rounded-pill me-1"><i class="fa fa-plus me-1"></i>Create Post</inertia-link>
				<button type="button" class="btn btn-sm btn-outline-secondary rounded-pill">Joined</button>
			</div>

		</div>
		
	</div>

	<div class="content">

		<div v-if="community!==null" class="row g-xxl-5 items-push">
			<div class="col-lg-8 mb-6">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div v-if="['Private'].includes(community.status) && ['Join','Requesting'].includes(community.join_status)" class="text-center">
							<h1 class="display-6 fw-bold text-info">
						        <i class="fa fa-flag me-1 opacity-50"></i>
						        <span>Community Post</span>
					     	</h1>
					     	<div v-if="community.join_status=='Join'">
						      	<h3 class="fw-bold mt-5 mb-2">Unauthorized to view the post...</h3>
						      	<h4 class="fw-medium text-muted mb-0">This community is a {{community.status}}.</h4>
						      	<p class="h4 mt-5">Request access to contribute on this post.</p>
						      	<button type="button" :disabled="formRequestToJoin.processing" @click="requestAccessToJoin()" class="btn btn-outline-info">
						      		<div
										v-if="formRequestToJoin.processing"
										class="spinner-border spinner-border-sm text-info me-1"
										role="status"
									>
										<span class="sr-only">Loading...</span>
									</div>
						      		<i v-else class="fa me-1 fa-lock me-1"></i>
							      	Requesting to join
					     	 	</button>
				     	 	</div>
				     	 	<div v-else>
				     	 		<p class="h4 mt-5">Your request is still being processed. Please allow 1–2 days for approval.</p>
				     	 	</div>
						</div>
						<div v-if="community.join_status=='Joined' || (community.join_status=='Join' && ['Public','Restricted'].includes(community.status))" v-for="(post,pIndex) in postsData" class="ribbon" :class="{'border-top':pIndex>0}">
							<div class="border border-1 border-light-secondary mb-1"></div>
							<div v-if="post.post_status!='Removed'" class="ribbon-box">
								<a href="javascript:void(0)" id="setting_post_{{pIndex}}" class="btn btn-alt-secondary btn-xs rounded-pill fw-bold" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</a>
								<div class="dropdown-menu" :aria-labelledby="'setting_post_'+pIndex" data-popper-placement="bottom-start">
				            		<a v-if="user.member_uuid==post.member_uuid" @click="post.is_edit=1" class="dropdown-item" href="javascript:void(0)"><label for="comment-textarea" class="cursor-pointer"><i class="fa fa-edit me-1"></i>Edit</label></a>
				            		<a v-if="user.member_uuid==post.member_uuid" @click="confirmDeletePost(post.post_uuid,pIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete</a>
			            			<a v-if="user.member_uuid==community.member_uuid && user.member_uuid!=post.member_uuid && post.is_spam==0" @click="confirmSpamPost(post.post_uuid,pIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-calendar-times me-1"></i>Mark as Spam</a>
				            		<a v-if="user.member_uuid==community.member_uuid" @click="confirmLockUnlockPost(post.post_uuid,post.lock_post,pIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':post.lock_post==0,'fa-unlock':post.lock_post==1}"></i>{{post.lock_post==1 ? 'Unlock' : 'Lock'}} Post</a>
				            		<a v-if="user.member_uuid!=post.member_uuid" @click="confirmReportPost(post.post_uuid,pIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
				            	</div>
							</div>
							<div class="block bg-transparent mb-2 ribbon ribbon-left ribbon-bottom">
								<inertia-link :href="'/member/community/c/'+community.community_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="block block-rounded block-link-shadow mb-1">
									<div class="block-header">
										<div class="block-title">
											<div class="mb-0">
												<img
													class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb m-0"
													:src="post.member_logo"
												/>
												<span v-if="post.post_status=='Removed' && community.member_uuid!=user.member_uuid && post.member_uuid!=user.member_uuid" class="fw-bold text-muted">
													[DELETED]
												</span>
												<inertia-link v-else :href="'/member/community/m/'+post.member_name" class="standard-link fw-semibold fs-sm text-info">{{post.member_name}}</inertia-link> 
												<span class="fs-xs text-muted ms-2">{{post.posted_at}}</span>
											</div>
										</div>
									</div>
									<div class="block-content block-content-full pt-0">
										<p v-if="(post.post_status=='Removed' || post.lock_post==1 || post.is_spam==1) && community.member_uuid!=user.member_uuid" class="m-0 mt-3 pb-5 fw-semibold text-muted text-cente h5">{{post.title}}</p>
										<div v-else>
											<span v-if="post.post_status=='Removed' || post.lock_post==1 || post.is_spam==1" class="badge bg-danger">{{post.post_status=='Removed' ? 'deleted' : post.lock_post==1 ? 'locked' : post.is_spam==1 ? 'spam' : '' }}</span>
											<div class="fw-semibold mt-3 h5 mb-0">{{post.title}}</div>
						                	<div class="fs-sm mt-4 pb-5" style="white-space: pre; white-space:break-spaces;" v-html="post.description"></div>
										</div>
									</div>
								</inertia-link>
								<div class="ribbon-box ps-4">
					            	<span class="me-3">
					            		<button @click="votePost(community.community_name,post.post_uuid,'like',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':post.vote==1}">
					            			<div
												v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='like'"
												class="spinner-border spinner-border-sm text-warning"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
					            			<i v-else class="fa fa-arrow-up"></i>
					            		</button>
					            		<span class="px-1">{{post.vote_total}}</span>
					            		<button @click="votePost(community.community_name,post.post_uuid,'dislike',post.vote,pIndex)" :disabled="formVotePost.processing && formVotePost.post_uuid==post.post_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':post.vote==-1}">
					            			<div
												v-if="formVotePost.processing && formVotePost.post_uuid==post.post_uuid & formVotePost.vote_label=='dislike'"
												class="spinner-border spinner-border-sm text-danger"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
					            			<i v-else class="fa fa-arrow-down"></i>
					            		</button>	
					            	</span>
					            	<inertia-link :href="'/member/community/c/'+community.community_name+'/post/'+post.post_uuid+'/'+post.slug_name" class="btn rounded-pill btn-sm btn-alt-secondary"><i class="fa fa-comment me-1"></i>{{post.comment_total}}</inertia-link>
					            </div>
							</div>
							<div v-if="post.is_edit==1" class="my-4">
								<form id="commentareaform" class="form-control block block-rounded">
									<div class="block m-0">
										<div class="block-content p-1">
											<textarea v-model="formPost.title" id="comment-textarea" name="comment-textarea" class="comment-textarea"></textarea>
											<div class="m-1">
												<div class="text-end">
													<button :disabled="formPost.processing && formPost.post_uuid==post.post_uuid" @click="post.is_edit=0,formPost.title=''" type="button" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
													<button :disabled="formPost.processing && formPost.post_uuid==post.post_uuid" @click="updatePost(post.post_uuid,pIndex)" type="button" class="btn btn-xs btn-info">
														<div
															v-if="formPost.processing && formPost.post_uuid==post.post_uuid"
															class="spinner-border spinner-border-sm text-white me-1"
															role="status"
														>
															<span class="sr-only">Loading...</span>
														</div>
														Save
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>

						<div v-if="posts.length<=0" class="text-center">
							<h1 class="display-6 fw-bold text-info">
						        <i class="fa fa-flag me-1 opacity-50"></i>
						        <span>Community Wall</span>
					     	</h1>
					      	<h3 class="fw-bold mt-5 mb-2">There Are No Community Posts Yet...</h3>
					      	<h4 class="fw-medium text-muted mb-0">Be the first to share your thoughts, ideas, or experiences. Start a discussion and connect with others in the community....</h4>
				      	</div>
					</div>
				</div>
				<div v-if="posts.length>4 && (is_lazy_loading || posts.length==postsData.length)" class="my-3 text-center">
					<span v-if="is_lazy_loading" class="text-info">
						<div
							class="spinner-border spinner-border-sm text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						Loading more...
					</span>
					<div v-else>
						<div
							v-if="is_reloading"
							class="spinner-border spinner-border-lg text-info"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<button v-else @click="reloadPage()" type="button" class="btn btn-xs btn-outline-info">
							<i class="fa fa-refresh me-1"></i>
							Reload the page
						</button>
					</div>
				</div>
			</div>

			<div v-if="community!==null" class="col-lg-4 mb-6 d-none d-sm-table-cell">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="fw-bold">{{community.community_name}}</div>
						<div class="fw-bold mb-2"><inertia-link :href="route('member.community.member-home',{'member_name':community.member_name})" class="standard-link text-black-75 fs-sm fw-normal">m/{{community.member_name}}</inertia-link></div>
						<div class="fs-xs mb-1"><i class="fa fa-calendar me-1"></i>Created {{community.created_at}}</div>
						<div class="fs-xs mb-1"><i class="fa me-1" :class="{'fa-globe':community.status=='Public','fa-eye':community.status=='Restricted','fa-lock':community.status=='Private'}"></i>{{community.status}}</div>
					</div>
					<div class="block-content block-content-full border-top border-1">
						<div class="row">
							<div class="col">
								<div class="text-info fw-bold">{{community.member_total}}</div>
								<span class="fs-xs">Member</span>
							</div>
							<div class="col">
								<div class="text-info fw-bold">{{community.visit_total}}</div>
								<span class="fs-xs">Visit</span>
							</div>
							<div class="col">
								<div class="text-info fw-bold">0</div>
								<span class="fs-xs">Online</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div v-else class="row">
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<h3 class="text-danger text-center">No Community Found...</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { debounce } from 'lodash';	
import { watch, onMounted, ref } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import ContentSlot from './ContentSlot';
import { createToaster } from '@meforma/vue-toaster'
import { useForm, usePage } from '@inertiajs/inertia-vue3'

export default {
	props:{
		user 		: Object,
		errors 		: Object,
		flash 		: Object,
		community 	: Object,
		posts 		: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const is_lazy_loading 	= ref(false);
		const is_reloading 		= ref(false);

		var postsData = (props.posts ? props.posts.slice(0,4) : []);

		const contentSlot = ref(null);

		const confirmDeletePostModal 		= ref(null);
		const confirmLockUnlockPostModal 	= ref(null);
		const confirmSpamPostModal 			= ref(null);
		const joinConfirmModal 				= ref(null);
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}


			window.addEventListener(
				'scroll',
				debounce((e) => {
					let body_height = document.body.clientHeight;
            		let end_height = window.scrollY + window.innerHeight;

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						// document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						// document.getElementById('scroll_top').classList.add('d-none')
					}

					if(body_height == end_height)
					{
						if(is_lazy_loading.value == false)
						{
							lazyLoad();
						}
					}

				}, 100)
			)
			
		})

		const formJoinCommunity = useForm({
			community_uuid 	: props.community.community_uuid,
			community_name 	: props.community.community_name,
			community_status: props.community.status,
			processing  	: false
		});

		const formVotePost = useForm({
			community_uuid 	: props.community.community_uuid,
			post_uuid 	: null,
			vote_label  : '',
			prev_vote  	: 0,
			vote  		: 0,
			processing 	: false
		});

		const formReloadPage = useForm({
			reload: true
		});

		const formPost = useForm({
			community_uuid 	: props.community.community_uuid,
			post_uuid 		: null,
			title 	 		: null,
			lock_post 		: 0,
			pIndex 			: 0,
			cache			: 'community_posts',
		});

		const updatePost = (_post_uuid,_pIndex)=>{

			formPost.post_uuid 	= _post_uuid;
			formPost.pIndex 	= _pIndex;

			formPost.put(route('member.community.post-update',{community_name:props.community.community_name,post_uuid:_post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){

								postsData[_pIndex].title 	= formPost.title;
								postsData[_pIndex].is_edit 	= 0;

								formPost.reset();

							}
						}
					})

		}

		const confirmDeletePost = (_post_uuid,_pIndex)=>{

			formPost.post_uuid 		= _post_uuid;
			formPost.pIndex 		= _pIndex;

			confirmDeletePostModal.value.toggleModal();

		}

		const deletePost = ()=>{

			formPost.delete(route('member.community.post-delete',{community_name:props.community.community_name,post_uuid:formPost.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors','post'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){

								confirmDeletePostModal.value.toggleModal();

								if(props.flash.toast.data.post_status=="Deleted"){
									delete postsData[formPost.pIndex];
								}else{
									postsData[formPost.pIndex].post_status 	= props.flash.toast.data.post_status;
									postsData[formPost.pIndex].removed_at 	= props.flash.toast.data.removed_at;
								}

								formPost.reset();
							}
						}
					})

		}


		const joinCommunity = (_uuid,_name,_status)=>{

			if(['Joined','Requesting'].includes(_status))
			{
				joinConfirmModal.value.toggleModal();
			}else{
				joinCommunityProcess();
			}
		}

		const joinCommunityProcess = (from_popup)=>{

			if(from_popup==='yes')
			{
				joinConfirmModal.value.toggleModal();
			}
			
			formJoinCommunity.processing 		= true;
		
			contentSlot.value.joinCommunity(formJoinCommunity,(res)=>{
				if(res)
				{
					formJoinCommunity.reset();
				}
			});
		}


		const votePost = (_com_name,_post_uuid,_vote_label,_val,_index)=>{

			formVotePost.post_uuid 			= _post_uuid;
			formVotePost.vote_label 		= _vote_label;
			formVotePost.processing 		= true;

			contentSlot.value.votePost(formVotePost.community_uuid,_com_name,_post_uuid,_vote_label,_val,_index,'community_posts',(res)=>{
				if(res)
				{
					postsData[_index].vote 			= props.flash.toast.data.vote;
					postsData[_index].vote_total 	= props.flash.toast.data.vote_total;
					postsData[_index].vote_weight 	= props.flash.toast.data.vote_weight;
				}
				formVotePost.reset();
			});

		}

		
		const confirmSpamPost = (_cuuid,_index)=>{
			formPost.post_uuid 	= _cuuid;
			formPost.pIndex  	= _index;

			confirmSpamPostModal.value.toggleModal();
		}


		const spamPost = ()=>{

			formPost.put(route('member.community.post-spam',{community_name:props.community.community_name,post_uuid:formPost.post_uuid}), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){
									let spam_message 	= props.flash.toast.data.spam_message;
									let pIndex 			= formPost.pIndex;

									confirmSpamPostModal.value.toggleModal();

									postsData[pIndex].is_spam 		= 1;
									postsData[pIndex].spam_message 	= spam_message;

									formPost.reset();
								}
							}
						})

		}


		const confirmLockUnlockPost = (_cuuid,_lock_post,_index)=>{
			formPost.post_uuid 	= _cuuid;
			formPost.lock_post  = (_lock_post == 1 ? 0 : 1);
			formPost.pIndex  	= _index;

			confirmLockUnlockPostModal.value.toggleModal();
		}


		const lockUnlockPost = ()=>{

			formPost.put(route('member.community.post-lock_unlock',{community_name:props.community.community_name,post_uuid:formPost.post_uuid}), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){

									let pIndex 			= formPost.pIndex;

									confirmLockUnlockPostModal.value.toggleModal();

									postsData[pIndex].lock_post = formPost.lock_post;

									formPost.reset();
								}
							}
						})

		}


		const lazyLoad = ()=>{
			
			let end_extract = postsData.length + 3;
			let new_posts = props.posts.slice(postsData.length,end_extract);
			
			if(props.posts.length > postsData.length)
			{
				is_lazy_loading.value = true;

				for (var i = 0; i < new_posts.length; i++) {
					postsData.push(new_posts[i]);
				}

				setTimeout(function(){
					is_lazy_loading.value = false;
				},1000);
			}
		}

		const reloadPage = ()=>{
			is_reloading.value = true;
			formReloadPage.post(route('member.community.community-home-reload',{community_name:props.community.community_name}), {
								preserveState: false,
								preserveScroll: false,
								only: ['flash','errors','posts'],
								onSuccess:()=>{
									let new_posts 		= null;

									postsData 			= [];

									is_reloading.value 	= false;

									new_posts 			= (props.posts ? props.posts.slice(0,4) : []);

									postsData.push(new_posts);
									
								},
								onError:()=>{
									is_reloading.value 		= false;
								}
							})

		}

		return{
			is_reloading,
			is_lazy_loading,
			contentSlot,
			postsData,
			confirmDeletePostModal,
			confirmLockUnlockPostModal,
			confirmSpamPostModal,
			joinConfirmModal,
			formPost,
			formJoinCommunity,
			formVotePost,
			formReloadPage,
			updatePost,
			confirmDeletePost,
			deletePost,
			confirmSpamPost,
			confirmLockUnlockPost,
			lockUnlockPost,
			spamPost,
			joinCommunity,
			joinCommunityProcess,
			votePost,
			lazyLoad,
			reloadPage
		}

	},
}
</script>
